export const EndorsementStatusConstants = {
    APPROVED: '5a73ac5c-a796-47fe-a080-434d68e6c0af',
    DECLINED: '75f9a04e-b5bc-47d5-a18a-7b71e6169503',
    PENDING: 'c4a92cbd-5771-4110-adbe-84edb8f311f2',
    PENDING_UPDATED: '43bf72bc-86d8-4604-8da5-c1b0b3de4c7c',
    DECLINE_WITH_FEEDBACK: '5b8e791a-56a9-4300-a425-d3d1b662a525',
    REVIEWED_WITH_FEEDBACK: '12ffa718-671b-409d-a790-fac68e04ad5b',
    APPROVED_WITH_FEEDBACK: 'cb542832-a666-4643-aa86-fb82170b9639',
};